export default "__VITE_ASSET__D8r1Ou4G__"